import { render, staticRenderFns } from "./RodapeTabela.vue?vue&type=template&id=28fbed18&scoped=true"
import script from "./RodapeTabela.vue?vue&type=script&lang=js"
export * from "./RodapeTabela.vue?vue&type=script&lang=js"
import style0 from "./RodapeTabela.vue?vue&type=style&index=0&id=28fbed18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fbed18",
  null
  
)

export default component.exports